import { ChangeDetectionStrategy, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from '../../functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-feature-list-container',
  templateUrl: './feature-list-container.component.html',
  styleUrls: ['./feature-list-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureListContainerComponent {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() title: string;
  @Input() tooltipText: string;
}
